// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"2c5de925","182":"009ca984"}[chunkId] + ".chunk.css";
};